import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'has_the_fac_conducted_an_assessment_to_identify_if_equipment_co'

export const dataPointDefinition = {
  retracedId: 'has_the_fac_conducted_an_assessment_to_identify_if_equipment_co',
  name: 'Has the facility conducted an assessment to identify if equipment contains PCB?',
  description:
    "PCBs are synthetic chlorinated hydrocarbon compounds, and have been used in plasticizers, surface coatings, inks, adhesives, flame retardants, pesticide extenders, paints, and microencapsulation of dyes for carbonless duplicating paper. Humans may be exposed to PCBs by inhaling contaminated air and ingesting contaminated water and food. The concentration of PCBs can be at least an order of magnitude higher in indoor air than in outdoor air. Studies have shown that exposure to PCBs is highly toxic to humans.\r\r\n\r\r\nAn 'assessment' may be a confirmation by a facility that all equipment and building materials were manufactured after the 100% prohibition of PCB use or 100% prohibition on PCB imports into the country.",
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-bui-12',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 14150,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
